module.exports = __webpack_public_path__ + "static/media/playButton.e0f25207.svg";